// extracted by mini-css-extract-plugin
export default {"joinCotainer":"joinByLink_joinCotainer__k-znz","offcameraContainer":"joinByLink_offcameraContainer__afBj1","otherOptionMicrophone":"joinByLink_otherOptionMicrophone__YHPpI"};